module.exports = __webpack_public_path__ + "img/wheel.c7a86278.png";